<template>
  <Modal @close="close" :modalActive="modalModel ? modalModel.modalActive : modalActive">
    <div class="modal-dialog-icon">
      <i class="fa fa-exclamation-triangle"></i>
    </div>
    <div class="modal-dialog-body">
      <h5 class="modal-dialog-title" v-html="modalModel ? modalModel.title : title"></h5>
      <p class="modal-dialog-message" v-html="modalModel ? modalModel.subTitle : subTitle"></p>
    </div>
    <div class="modal-dialog-actions">
      <button v-show="modalModel ? modalModel.nBtn : nBtn" @click="close" class="modal-btn modal-btn-cancel">
        {{ modalModel ? modalModel.nBtn : nBtn }}
      </button>
      <button v-show="modalModel ? modalModel.yBtn : yBtn" @click="onApproveAction" class="modal-btn modal-btn-confirm">
        {{ modalModel ? modalModel.yBtn : yBtn }}
      </button>
    </div>
  </Modal>
</template>

<script>

import Modal from './Modal-Base'

export default {
  name: 'ModalDialog',
  data(){
    return {
    }
  },
  props: [
    'modalActive',
    'title',
    'subTitle',
    'yBtn',
    'nBtn',
    'modalData',
    'modalModel'
  ],
  components:{
    Modal
  },
  methods:{
    onApproveAction(){
      if( (this.modalModel && this.modalModel.yBtn ) || this.yBtn != null)
        this.approve()
    },
    close () {
      this.$emit('close', this.modalModel ? this.modalModel.modalData : this.modalData)
    },
    approve () {
      this.$emit('approve', this.modalModel ? this.modalModel.modalData : this.modalData)
      this.close()
    }
  }
}
</script>

<style>
.modal-dialog-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #fff3f3;
  border: 2px solid #fecaca;
  margin: 0 auto 20px;
}

.modal-dialog-icon .fa-exclamation-triangle {
  font-size: 24px;
  color: #ef4444;
  display: inline-block;
  margin-bottom: 0;
}

.modal-dialog-body {
  text-align: center;
  margin-bottom: 28px;
}

.modal-dialog-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
}

.modal-dialog-message {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 0;
}

.modal-dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modal-btn {
  flex: 1;
  padding: 11px 20px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.modal-btn-cancel {
  background: #f1f5f9;
  color: #475569;
  border: 1.5px solid #e2e8f0;
}

.modal-btn-cancel:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.modal-btn-confirm {
  background: #ef4444;
  color: #ffffff;
}

.modal-btn-confirm:hover {
  background: #dc2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35);
}
</style>
